import React from 'react';
import { clientLogos } from '../../lib/data';
export function LogoMarquee() {
  const doubled = [...clientLogos, ...clientLogos];
  return <section className="border-b border-ink/10 py-10" data-id="element-90" data-mp="1fn3k1c3tjxv8">
      <p className="mb-8 text-center text-xs uppercase tracking-widest2 text-ink-500" data-id="element-91" data-mp="1kfd3qaecc1p2">
        Chosen by the world’s most ambitious organisations
      </p>
      <div className="relative overflow-hidden" data-id="element-92" data-mp="1pgst2enjwud9">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-ivory-100 to-transparent" data-id="element-93" data-mp="rrqy6wljymzk" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-ivory-100 to-transparent" data-id="element-94" data-mp="wqap7bf06oys" />
        <div className="flex w-max animate-marquee items-center gap-14" data-id="element-95" data-mp="16o8bhtdaybor">
          {doubled.map((logo, i) => <span key={i} className="font-serif text-xl tracking-widest2 text-ink-400 transition-colors hover:text-ink" data-id="element-96" data-mp="2d4kb7yvrw1mg" data-mpi={i}>
              {logo}
            </span>)}
        </div>
      </div>
    </section>;
}